module.exports = __webpack_public_path__ + "static/media/ph_gift-bold.ab29c45f.svg";